export default __webpack_public_path__ + "static/media/hand.5e070589.svg";